import { render, staticRenderFns } from "./PatientOverviewMedication.vue?vue&type=template&id=61fca647&"
import script from "./PatientOverviewMedication.vue?vue&type=script&lang=js&"
export * from "./PatientOverviewMedication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports